export default __webpack_public_path__ + "static/media/56.2ff70859.jpg";